import { request } from '@/utils/request'
import { StatusOption, type DataDownLoad, type DataDownLoadParams, type DownloadLog, type LogData } from './types'
import { devops } from './api'

/**
 * 数据下载列表
 * @returns
 */
export const getDataDownLoadList = async (params: DataDownLoadParams) => {
  return request<DataDownLoad>(devops.dataDownloadList, params)
}

/**
 * 数据下载列表 - 删除
 * @returns
 */
export const deleteDataDownLoadList = async (id: number) => {
  return request(devops.delete, id)
}

/**
 * 数据下载列表 - 日志
 * @returns
 */
export const getLog = async (id: number, pageNum: number, pageSize: number) => {
  return request<LogData>(devops.log, id, pageNum, pageSize)
}

/**
 * 数据下载列表 - 下载
 * @returns
 */
export const dataDownload = async (id: number, fileName: string) => {
  return request<DownloadLog>(devops.download, id, fileName)
}

export const getApprovalStatusOption = () => {
  return request<StatusOption[]>(devops.getApprovalStatusOption)
}
